// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"3d66eb0562c4d0fd568c","245":"dcafd981b98072a0a6ad","452":"6613ca55ebeaeb088929","453":"a79c7fd2cd0c424c7b04"}[chunkId] + ".js";
};